import * as React from 'react';
import { useSelector } from 'react-redux';
import { plural } from '@cian/utils';
import { Discounts as DiscountsComponent } from '../../components/Discounts';
import { getDiscounts } from '../../selectors';
import { DiscountCard } from '../DiscountCard';
import { ShowMoreLink } from '../../components/ShowMoreLink';

export const MAX_VISIBLE_DISCOUNTS = 3;

export function Discounts() {
  const [showAll, setShowAll] = React.useState(false);
  const discounts = useSelector(getDiscounts);
  const discountsForRender = React.useMemo(
    () => (showAll ? discounts : discounts.slice(0, MAX_VISIBLE_DISCOUNTS)),
    [discounts, showAll],
  );
  const remainingDiscounts = discounts.length - discountsForRender.length;
  const cards = React.useMemo(
    () => discountsForRender.map(discount => <DiscountCard key={discount.id} discountId={discount.id} />),
    [discountsForRender],
  );

  const handleShowAll = React.useCallback(() => setShowAll(true), []);

  if (!discountsForRender.length) {
    return null;
  }

  return (
    <DiscountsComponent
      discountCards={cards}
      showMore={
        !showAll && discounts.length > MAX_VISIBLE_DISCOUNTS ? (
          <ShowMoreLink onClick={handleShowAll}>
            Показать еще {remainingDiscounts} {plural(remainingDiscounts, ['акцию', 'акции', 'акций'])}
          </ShowMoreLink>
        ) : null
      }
    />
  );
}
